import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppealsService } from 'src/app/services/appeals.service';
import { DataService } from 'src/app/services/data.service';
import SwiperCore, { SwiperOptions,Pagination,Navigation, Swiper,EffectCoverflow } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
SwiperCore.use([Pagination,Navigation,EffectCoverflow ]);

@Component({
  selector: 'app-violation-info',
  templateUrl: './violation-info.page.html',
  styleUrls: ['./violation-info.page.scss'],
})
export class ViolationInfoPage implements OnInit {
  @ViewChild('swiper') swiper: SwiperComponent;
  slides: Swiper;
  config: SwiperOptions = {
    effect:'coverflow',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    slidesPerView: 1,
    centeredSlides:true,
    pagination:true
  };
  @Input() violation: any;
  constructor(
    public appealsSRV: AppealsService,
    public modalController: ModalController,
    public dataService: DataService) {}

  ngOnInit() {
 
  
  }
  onCancelModal() {
   
    this.modalController.dismiss({
      dismissed: true,
    });
  }
}
